// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__1Id3n","NavItems":"Navbar_NavItems__3I9Su","DesktopOnly":"Navbar_DesktopOnly__1Bwer"};